<app-quota-summary-bar></app-quota-summary-bar>
<div class="register-container">
  <div class="register-header">
    <h1>{{ 'applicationsRegister.title' | translate }}</h1>
  </div>
  <!-- Кнопки фильтров по статусу -->
  <app-status-filter
    [statusFilter]="statusFilter"
    [statusCounts]="statusCounts()"
    (statusChange)="setStatusFilter($event)">
  </app-status-filter>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'applicationsRegister.loading' | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-raised-button color="primary" (click)="loadApplications()">
        {{ 'applicationsRegister.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="table-container" [class.table-filtering]="filtering()">
      <table mat-table [dataSource]="applications()" class="applications-table">
        <!-- № -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header">№</div>
          </th>
          <td mat-cell *matCellDef="let app; let i = index" class="text-right">{{ i + 1 }}</td>
        </ng-container>

        <!-- Номер заявки -->
        <ng-container matColumnDef="applicationNumber">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">{{ 'applicationsRegister.applicationNumber' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.applicationNumber }}</td>
        </ng-container>

        <!-- Компания -->
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef class="company-name-col">
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.companyName' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.companyName" (click)="toggleColumnFilter('companyName')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'companyName'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.companyName"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.companyName" class="clear-icon" (click)="clearFilter('companyName')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app" class="company-name-col" [title]="app.companyName">{{ app.companyName }}</td>
        </ng-container>

        <!-- ИНН -->
        <ng-container matColumnDef="companyInn">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.companyInn' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.companyInn" (click)="toggleColumnFilter('companyInn')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'companyInn'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.companyInn"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.companyInn" class="clear-icon" (click)="clearFilter('companyInn')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.companyInn }}</td>
        </ng-container>

        <!-- Номер доверенности -->
        <ng-container matColumnDef="proxyDocumentNumber">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.proxyNumber' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.proxyDocumentNumber" (click)="toggleColumnFilter('proxyDocumentNumber')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'proxyDocumentNumber'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.proxyDocumentNumber"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.proxyDocumentNumber" class="clear-icon" (click)="clearFilter('proxyDocumentNumber')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.proxyDocumentNumber || '-' }}</td>
        </ng-container>

        <!-- Дата доверенности -->
        <ng-container matColumnDef="proxyDocumentDate">
          <th mat-header-cell *matHeaderCellDef class="text-right date-filter-cell">
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.proxyDate' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.contractDateFrom || filters.contractDateTo" (click)="toggleColumnFilter('proxyDocumentDate')">filter_list</mat-icon>
            </div>
            <div class="date-filter-wrapper" [hidden]="openFilterColumn !== 'proxyDocumentDate'">
              <mat-form-field appearance="outline" class="date-field">
                <input matInput [matDatepicker]="dateFromPicker" [(ngModel)]="filters.contractDateFrom" (ngModelChange)="onFilterChange()" [placeholder]="'applicationsRegister.from' | translate" readonly>
                <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" *ngIf="!filters.contractDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateFromPicker></mat-datepicker>
                <button matSuffix mat-icon-button *ngIf="filters.contractDateFrom" (click)="clearFilter('contractDateFrom'); $event.stopPropagation();" class="clear-date-btn">
                  <mat-icon class="clear-date-icon-small">close</mat-icon>
                </button>
              </mat-form-field>
              <mat-form-field appearance="outline" class="date-field">
                <input matInput [matDatepicker]="dateToPicker" [(ngModel)]="filters.contractDateTo" (ngModelChange)="onFilterChange()" [placeholder]="'applicationsRegister.to' | translate" readonly>
                <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" *ngIf="!filters.contractDateTo"></mat-datepicker-toggle>
                <mat-datepicker #dateToPicker></mat-datepicker>
                <button matSuffix mat-icon-button *ngIf="filters.contractDateTo" (click)="clearFilter('contractDateTo'); $event.stopPropagation();" class="clear-date-btn">
                  <mat-icon class="clear-date-icon-small">close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.proxyDocumentDate || '-' }}</td>
        </ng-container>

        <!-- Дата ВРМСХ -->
        <ng-container matColumnDef="vetServiceIssueDate">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header">{{ 'applicationsRegister.vrmsxDate' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.vetServiceIssueDate || '-' }}</td>
        </ng-container>

        <!-- Номер ВРМСХ -->
        <ng-container matColumnDef="vetServiceIssueNumber">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.vrmsxNumber' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.vetServiceIssueNumber" (click)="toggleColumnFilter('vetServiceIssueNumber')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'vetServiceIssueNumber'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.vetServiceIssueNumber"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.vetServiceIssueNumber" class="clear-icon" (click)="clearFilter('vetServiceIssueNumber')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.vetServiceIssueNumber || '-' }}</td>
        </ng-container>

        <!-- ФИО Заявителя -->
        <ng-container matColumnDef="applicantFullName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.applicantName' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.namePatronymic" (click)="toggleColumnFilter('applicantFullName')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'applicantFullName'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.namePatronymic"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.namePatronymic" class="clear-icon" (click)="clearFilter('namePatronymic')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.applicantFullName }}</td>
        </ng-container>

        <!-- Номер паспорта -->
        <ng-container matColumnDef="applicantPassportNumber">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.passportNumber' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.passportNumber" (click)="toggleColumnFilter('applicantPassportNumber')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'applicantPassportNumber'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.passportNumber"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.passportNumber" class="clear-icon" (click)="clearFilter('passportNumber')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.applicantPassportNumber }}</td>
        </ng-container>

        <!-- Номер телефона -->
        <ng-container matColumnDef="applicantPhoneNumber">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.phoneNumber' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.phoneNumber" (click)="toggleColumnFilter('applicantPhoneNumber')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'applicantPhoneNumber'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.phoneNumber"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.phoneNumber" class="clear-icon" (click)="clearFilter('phoneNumber')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.applicantPhoneNumber }}</td>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="applicantEmail">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.email' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.email" (click)="toggleColumnFilter('applicantEmail')">filter_list</mat-icon>
            </div>
            <div *ngIf="openFilterColumn === 'applicantEmail'" class="filter-input-wrapper">
              <input
                class="column-filter"
                placeholder="..."
                [(ngModel)]="filters.email"
                (ngModelChange)="onFilterChange()">
              <mat-icon *ngIf="filters.email" class="clear-icon" (click)="clearFilter('email')">close</mat-icon>
            </div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.applicantEmail }}</td>
        </ng-container>

        <!-- Тип мяса -->
        <ng-container matColumnDef="meatType">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.meatType' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.meatTypeId" (click)="toggleColumnFilter('meatType')">filter_list</mat-icon>
            </div>
            <select
              *ngIf="openFilterColumn === 'meatType'"
              class="column-filter"
              [(ngModel)]="filters.meatTypeId"
              (ngModelChange)="onFilterChange()">
              <option [ngValue]="null">{{ 'applicationsRegister.all' | translate }}</option>
              <option [ngValue]="1">{{ 'applicationsRegister.beef' | translate }}</option>
              <option [ngValue]="2">{{ 'applicationsRegister.pork' | translate }}</option>
              <option [ngValue]="3">{{ 'applicationsRegister.chicken' | translate }}</option>
            </select>
          </th>
          <td mat-cell *matCellDef="let app">{{ getMeatTypeName(app.meatType) }}</td>
        </ng-container>

        <!-- Объем -->
        <ng-container matColumnDef="requestedVolume">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header">{{ 'applicationsRegister.requestedVolume' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.requestedVolume | kgToTons }}</td>
        </ng-container>

        <!-- За 9 месяцев -->
        <ng-container matColumnDef="volumeForLastNineMonths">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header">{{ 'applicationsRegister.for9months' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.volumeForLastNineMonths | kgToTons }}</td>
        </ng-container>

        <!-- За 12 месяцев -->
        <ng-container matColumnDef="volumeForLastTwelveMonths">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <div class="column-header">{{ 'applicationsRegister.for12months' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app" class="text-right">{{ app.volumeForLastTwelveMonths | kgToTons }}</td>
        </ng-container>

        <!-- Тип поставщика -->
        <ng-container matColumnDef="supplierType">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header-wrapper">
              <span>{{ 'applicationsRegister.supplierType' | translate }}</span>
              <mat-icon class="filter-icon" [class.filter-active]="filters.supplierType" (click)="toggleColumnFilter('supplierType')">filter_list</mat-icon>
            </div>
            <select
              *ngIf="openFilterColumn === 'supplierType'"
              class="column-filter"
              [(ngModel)]="filters.supplierType"
              (ngModelChange)="onFilterChange()">
              <option value="">{{ 'applicationsRegister.all' | translate }}</option>
              <option value="NEW_SUPPLIER">{{ 'applicationsRegister.newSupplier' | translate }}</option>
              <option value="HISTORICAL_SUPPLIER">{{ 'applicationsRegister.historicalSupplier' | translate }}</option>
            </select>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.supplierType | supplierType }}</td>
        </ng-container>

        <!-- ВРМСХ -->
        <ng-container matColumnDef="veterinaryDocumentStatus">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">{{ 'applicationsRegister.vrmsx' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.veterinaryDocumentStatus | vetDocStatus }}</td>
        </ng-container>

        <!-- Статус квоты -->
        <ng-container matColumnDef="quotaStatus">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">{{ 'applicationsRegister.quotaStatus' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app">{{ app.quotaStatus | quotaStatus }}</td>
        </ng-container>

        <!-- Статус заявки -->
        <ng-container matColumnDef="applicationStatus">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">{{ 'applicationsRegister.applicationStatus' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app">
            <span class="status-chip" [ngClass]="app.applicationStatus | statusClass">
              {{ app.applicationStatus | statusLabel }}
            </span>
          </td>
        </ng-container>

        <!-- Действия -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <div class="column-header">{{ 'applicationsRegister.action' | translate }}</div>
          </th>
          <td mat-cell *matCellDef="let app">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu">
              @if (app.applicationStatus !== 'APPROVED' && app.applicationStatus !== 'REJECTED') {
                @if (app.veterinaryDocumentStatus) {
                  <button mat-menu-item (click)="approveApplication(app)">
                    <!-- <mat-icon>check_circle</mat-icon> -->
                    <span>{{ 'applicationsRegister.accept' | translate }}</span>
                  </button>
                } @else {
                  <button mat-menu-item disabled [matTooltip]="'applicationsRegister.specifyVrmsxTooltip' | translate">
                    <!-- <mat-icon>check_circle</mat-icon> -->
                    <span>{{ 'applicationsRegister.accept' | translate }}</span>
                  </button>
                }
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="rejectApplication(app)">
                  <!-- <mat-icon>cancel</mat-icon> -->
                  <span>{{ 'applicationsRegister.reject' | translate }}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="setVrmsx(app)">
                  <!-- <mat-icon>assignment</mat-icon> -->
                  <span>{{ 'applicationsRegister.specifyVrmsx' | translate }}</span>
                </button>
                <mat-divider></mat-divider>
              }
              @if (app.applicationStatus !== 'REJECTED') {
                <button mat-menu-item (click)="setLastDeliveries(app)">
                  <!-- <mat-icon>local_shipping</mat-icon> -->
                  <span>{{ 'applicationsRegister.makeHistorical' | translate }}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item (click)="setUnderConsideration(app)">
                  <!-- <mat-icon>pending</mat-icon> -->
                  <span>{{ 'applicationsRegister.setUnderConsideration' | translate }}</span>
                </button>
                <mat-divider></mat-divider>
              }
              <button mat-menu-item (click)="downloadPdfReport(app)">
                <!-- <mat-icon>picture_as_pdf</mat-icon> -->
                <span>{{ 'applicationsRegister.downloadPdf' | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>

        <!-- Пустое состояние -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns().length">
            {{ 'applicationsRegister.noApplications' | translate }}
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="pagination.totalElements()"
      [pageSize]="pagination.pageSize()"
      [pageIndex]="pagination.currentPage()"
      [pageSizeOptions]="[10, 15, 25, 50, 100]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  }
</div>
